import mainTranslate from 'loankeeper-common/helpers/language'

export const translate = (key: string): string => mainTranslate(`frm_ucc_pay-${key}`)
export const translator = (key: string): string => mainTranslate(`frm_app_screening_add_edit-${key}`)
export const translateLKMessage = (name: string): string => mainTranslate(`LKMESSAGE-${name}`)
export const round = (value: number) => Math.round(value * 100) / 100
